// Credit costs for each feature
export const CREDIT_COSTS = {
  QuickStories: 4,
  StoryNarrator: 4,
  StoryBook: 8,
  PhotoBook: 8,
};

// Helper function to get cost for a feature
export const getCreditCost = (featureName) => {
  return CREDIT_COSTS[featureName] || 0;
}; 